import React from 'react';

import ListNav from '../../../../../components/ListNav';
import useMemberListNeighbors from '../useMemberListNeighbors';

const MemberDetailsNav: React.FC = () => {
    const { prev, next, backTo, position } = useMemberListNeighbors();

    return (
        <ListNav
            backLabel="Members"
            backAlt="Back to members"
            backTo={backTo}
            prev={prev}
            next={next}
            position={position}
        />
    );
};

export default MemberDetailsNav;
